var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 64,
    height: 64,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 12h18c5.8 0 10.4 4.6 10.4 10.4V50c-2.4-2.1-5.6-3.2-9-3.2H12c-1.1 0-2-.9-2-2V14c0-1.1.9-2 2-2Z",
    opacity: 0.92
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 12H34c-5.8 0-10.4 4.6-10.4 10.4V50c2.4-2.1 5.6-3.2 9-3.2H52c1.1 0 2-.9 2-2V14c0-1.1-.9-2-2-2Z",
    opacity: 0.82
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 15.5a2 2 0 0 1 2 2V33l-2.1-1.5-2.1 1.5V17.5a2 2 0 0 1 2-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 24.2h8.8M20 29.2h7.1M36 24.2h8.8M36 29.2h7.1",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 14,
    r: 7,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    opacity: 0.72
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 14,
    r: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9b095ff826d3a522aa90433d25c77b40.svg";
export { ForwardRef as ReactComponent };